<div class="h-100 container-fluid d-flex admin flex-column">

  <div class="d-flex flex-row mb-5 w-100">
    <div class="d-flex flex-row align-items-center gap1">
      <h1 class="fw-bold">Liste des utilisateurs</h1>
      <mat-icon class="d-flex align-items-center justify-content-center pointer font-18" (click)="refresh()">
        autorenew
      </mat-icon>
    </div>

    <div class="ms-auto d-flex align-items-center gap-24">
      <mat-form-field class="search_box">
        <mat-icon class="search-icon" aria-hidden="false" aria-label="Example home icon" fontIcon="search"></mat-icon>
        <input matInput [(ngModel)]="search" placeholder="Rechercher">
        <!--        <mat-hint>Ex: Jean Dupont</mat-hint>-->
      </mat-form-field>
      <div class="col-6">
        <button (click)="refresh()" class="btn btn-primary">Search</button>
      </div>
    </div>

  </div>

  <div class="mt-4 overflow-auto table_container flex-grow-1" *ngIf="!isloading">

    <table mat-table [dataSource]="dataSource" matSort class="w-100" *ngIf="users && users.length > 0">

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="me-5">Nom</span>
          <span class="me-5">ID</span>
          <span class="me-5">Nationalité</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex flex-row align-items-center gap1 py-2">
            <app-avatar-filler [user]="element" [size]="'sm'"></app-avatar-filler>
            <div>
             <h2 class="m-0 font-18 ">{{ element.firstname + ' ' + element.lastname }}
              <a class="font-14 lightGray2" routerLink="{{element.id}}">#{{element.id}}</a>
             </h2>
              <span>{{ ('COUNTRIES.' + element.nationality) | translate }}</span>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Progress Column -->
      <ng-container matColumnDef="progress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Header à venir </th>
        <td mat-cell *matCellDef="let element"> data à venir </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Header à venir  </th>
        <td mat-cell *matCellDef="let element"> data à venir </td>
      </ng-container>

      <!-- Fruit Column -->
      <ng-container matColumnDef="fruit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Inscrit depuis le </th>
        <td mat-cell *matCellDef="let element"> {{ element.created_at | date:'shortDate':'':'FR' }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">Aucun résultat trouvé.</td>
      </tr>
    </table>

  </div>

  <div class="flex-grow-1 d-flex align-items-center justify-content-center mb-5" *ngIf="isloading">
    <div class="spinner-border text-primary"></div>
  </div>

  <app-pagination [page]="page" (changePage)="changePage($event)" [hasMore]="hasMore"
                  (perPageEmitter)="changePerPage($event)" [maxPage]="maxPage"></app-pagination>

</div>
